import React from 'react';

interface Props {
    goResult: (type: string) => void;
}

const CheckButton: React.FC<Props> = ({
    goResult,
}) => {
    return (
        <>
            <div className="center mt20">
                <button type="button" onClick={() => goResult("cancel")} className="m white">취소하기</button>
                <button type="button" onClick={() => goResult("success")} className="m blue">결과보기</button>
            </div>
            <div className="banner">
                <a href="http://www.hugin.co.kr/" target="_blank" rel="noreferrer"><img src="/images/therapy/banner_hugin.png" alt="허그인사이트 바로가기"></img></a>
            </div>
        </>
    )
}

export default CheckButton;